import { type ApiService } from '../types/ApiService';

export const inmateNotification = (centralApi: ApiService) => ({
  post: (data) => {
    return centralApi.post('/inmate-notification', data);
  },
  delete: (id) => {
    return centralApi.delete(`/inmate-notification/${id}`);
  },
});
